import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { InvoiceBillingAddressComponent } from './components/invoice-billing-address/invoice-billing-address.component'
import { Tv3PlatformModule } from '@tokeet/tv3-platform'
import { SelectBillingAddressDialogComponent } from './components/select-billing-address-dialog/select-billing-address-dialog.component'
import { BillingAddressDialogComponent } from './components/billing-address-dialog/billing-address-dialog.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgSelectModule } from '@ng-select/ng-select'
import { MatInputModule } from '@angular/material/input'
import { SendInvoiceLaterDialogComponent } from './components/send-invoice-later-dialog/send-invoice-later-dialog.component'
import { MatAutocompleteModule } from '@angular/material/autocomplete'

const components = [
  InvoiceBillingAddressComponent,
  SelectBillingAddressDialogComponent,
  BillingAddressDialogComponent,
  SendInvoiceLaterDialogComponent,
]

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule,
    Tv3PlatformModule,
    NgSelectModule,
  ],
  declarations: [...components],
  exports: [...components],
})
export class InvoiceLibModule {}
